/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import { customInstance } from '.././instance';
import type { ErrorType } from '.././instance';
import type {
	CreateComponentRequest,
	CreatePolicyPlanRequest,
	ListPolicyPlanComponentsParams,
	PolicyPlan,
	PolicyPlanComponentListResponse,
	PolicyPlanListResponse,
	PolicyPlanVersion,
	PolicyPlanVersionListResponse,
	PraetoidError,
	ReorderComponentsRequest,
	UpdateComponentRequest,
	UpdatePolicyPlanRequest
} from '../models';

/**
 * Returns all policy plans for the organization
 * @summary List policy plans
 */
export const listPolicyPlans = () => {
	return customInstance<PolicyPlanListResponse>({ url: `/policy-plans`, method: 'GET' });
};

export const getListPolicyPlansQueryKey = () => {
	return ['policy-plans'] as const;
};

export const getListPolicyPlansQueryOptions = <
	TData = Awaited<ReturnType<typeof listPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlans>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPolicyPlansQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyPlans>>> = () =>
		listPolicyPlans();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPolicyPlans>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPolicyPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listPolicyPlans>>>;
export type ListPolicyPlansQueryError = ErrorType<PraetoidError>;

export function useListPolicyPlans<
	TData = Awaited<ReturnType<typeof listPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlans>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlans>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlans>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlans<
	TData = Awaited<ReturnType<typeof listPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlans>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlans>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlans>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlans<
	TData = Awaited<ReturnType<typeof listPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlans>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List policy plans
 */

export function useListPolicyPlans<
	TData = Awaited<ReturnType<typeof listPolicyPlans>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlans>>, TError, TData>>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPolicyPlansQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new policy plan for the organization. If `praetor_id` is provided, the plan is also attached as a praetor component on that praetor's draft in the same transaction.
 * @summary Create a policy plan
 */
export const createPolicyPlan = (createPolicyPlanRequest: CreatePolicyPlanRequest) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createPolicyPlanRequest
	});
};

export const getCreatePolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPolicyPlan>>,
		TError,
		{ data: CreatePolicyPlanRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createPolicyPlan>>,
	TError,
	{ data: CreatePolicyPlanRequest },
	TContext
> => {
	const mutationKey = ['createPolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createPolicyPlan>>,
		{ data: CreatePolicyPlanRequest }
	> = (props) => {
		const { data } = props ?? {};

		return createPolicyPlan(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreatePolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof createPolicyPlan>>
>;
export type CreatePolicyPlanMutationBody = CreatePolicyPlanRequest;
export type CreatePolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a policy plan
 */
export const useCreatePolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createPolicyPlan>>,
			TError,
			{ data: CreatePolicyPlanRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createPolicyPlan>>,
	TError,
	{ data: CreatePolicyPlanRequest },
	TContext
> => {
	return useMutation(getCreatePolicyPlanMutationOptions(options), queryClient);
};
/**
 * Deletes a policy plan.
 * @summary Delete a policy plan
 */
export const deletePolicyPlan = (id: string) => {
	return customInstance<void>({ url: `/policy-plans/${id}`, method: 'DELETE' });
};

export const getDeletePolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deletePolicyPlan>>,
		TError,
		{ id: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deletePolicyPlan>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ['deletePolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deletePolicyPlan>>,
		{ id: string }
	> = (props) => {
		const { id } = props ?? {};

		return deletePolicyPlan(id);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeletePolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof deletePolicyPlan>>
>;

export type DeletePolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete a policy plan
 */
export const useDeletePolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deletePolicyPlan>>,
			TError,
			{ id: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deletePolicyPlan>>,
	TError,
	{ id: string },
	TContext
> => {
	return useMutation(getDeletePolicyPlanMutationOptions(options), queryClient);
};
/**
 * Creates a new policy plan version
 * @summary Update a policy plan
 */
export const updatePolicyPlan = (id: string, updatePolicyPlanRequest: UpdatePolicyPlanRequest) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans/${id}`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: updatePolicyPlanRequest
	});
};

export const getUpdatePolicyPlanMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePolicyPlan>>,
		TError,
		{ id: string; data: UpdatePolicyPlanRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePolicyPlan>>,
	TError,
	{ id: string; data: UpdatePolicyPlanRequest },
	TContext
> => {
	const mutationKey = ['updatePolicyPlan'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePolicyPlan>>,
		{ id: string; data: UpdatePolicyPlanRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePolicyPlan(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePolicyPlanMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePolicyPlan>>
>;
export type UpdatePolicyPlanMutationBody = UpdatePolicyPlanRequest;
export type UpdatePolicyPlanMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update a policy plan
 */
export const useUpdatePolicyPlan = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePolicyPlan>>,
			TError,
			{ id: string; data: UpdatePolicyPlanRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePolicyPlan>>,
	TError,
	{ id: string; data: UpdatePolicyPlanRequest },
	TContext
> => {
	return useMutation(getUpdatePolicyPlanMutationOptions(options), queryClient);
};
/**
 * Returns components for a policy plan. When no version is provided, the latest version is used.
 * @summary List policy plan components
 */
export const listPolicyPlanComponents = (id: string, params?: ListPolicyPlanComponentsParams) => {
	return customInstance<PolicyPlanComponentListResponse>({
		url: `/policy-plans/${id}/components`,
		method: 'GET',
		params
	});
};

export const getListPolicyPlanComponentsQueryKey = (
	id: string,
	params?: ListPolicyPlanComponentsParams
) => {
	return ['policy-plans', id, 'components', ...(params ? [params] : [])] as const;
};

export const getListPolicyPlanComponentsQueryOptions = <
	TData = Awaited<ReturnType<typeof listPolicyPlanComponents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	params?: ListPolicyPlanComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanComponents>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPolicyPlanComponentsQueryKey(id, params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyPlanComponents>>> = () =>
		listPolicyPlanComponents(id, params);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPolicyPlanComponents>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPolicyPlanComponentsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPolicyPlanComponents>>
>;
export type ListPolicyPlanComponentsQueryError = ErrorType<PraetoidError>;

export function useListPolicyPlanComponents<
	TData = Awaited<ReturnType<typeof listPolicyPlanComponents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	params: undefined | ListPolicyPlanComponentsParams,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanComponents>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlanComponents>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlanComponents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlanComponents<
	TData = Awaited<ReturnType<typeof listPolicyPlanComponents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	params?: ListPolicyPlanComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanComponents>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlanComponents>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlanComponents>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlanComponents<
	TData = Awaited<ReturnType<typeof listPolicyPlanComponents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	params?: ListPolicyPlanComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanComponents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List policy plan components
 */

export function useListPolicyPlanComponents<
	TData = Awaited<ReturnType<typeof listPolicyPlanComponents>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	params?: ListPolicyPlanComponentsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanComponents>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPolicyPlanComponentsQueryOptions(id, params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Adds a component to a policy plan (triggers COW if needed)
 * @summary Create a policy plan component
 */
export const createPolicyPlanComponent = (
	id: string,
	createComponentRequest: CreateComponentRequest
) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans/${id}/components`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: createComponentRequest
	});
};

export const getCreatePolicyPlanComponentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createPolicyPlanComponent>>,
		TError,
		{ id: string; data: CreateComponentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createPolicyPlanComponent>>,
	TError,
	{ id: string; data: CreateComponentRequest },
	TContext
> => {
	const mutationKey = ['createPolicyPlanComponent'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createPolicyPlanComponent>>,
		{ id: string; data: CreateComponentRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return createPolicyPlanComponent(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreatePolicyPlanComponentMutationResult = NonNullable<
	Awaited<ReturnType<typeof createPolicyPlanComponent>>
>;
export type CreatePolicyPlanComponentMutationBody = CreateComponentRequest;
export type CreatePolicyPlanComponentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Create a policy plan component
 */
export const useCreatePolicyPlanComponent = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createPolicyPlanComponent>>,
			TError,
			{ id: string; data: CreateComponentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof createPolicyPlanComponent>>,
	TError,
	{ id: string; data: CreateComponentRequest },
	TContext
> => {
	return useMutation(getCreatePolicyPlanComponentMutationOptions(options), queryClient);
};
/**
 * Reorders components on a policy plan (triggers COW if needed)
 * @summary Reorder policy plan components
 */
export const reorderPolicyPlanComponents = (
	id: string,
	reorderComponentsRequest: ReorderComponentsRequest
) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans/${id}/components/order`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: reorderComponentsRequest
	});
};

export const getReorderPolicyPlanComponentsMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof reorderPolicyPlanComponents>>,
		TError,
		{ id: string; data: ReorderComponentsRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof reorderPolicyPlanComponents>>,
	TError,
	{ id: string; data: ReorderComponentsRequest },
	TContext
> => {
	const mutationKey = ['reorderPolicyPlanComponents'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderPolicyPlanComponents>>,
		{ id: string; data: ReorderComponentsRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return reorderPolicyPlanComponents(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderPolicyPlanComponentsMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderPolicyPlanComponents>>
>;
export type ReorderPolicyPlanComponentsMutationBody = ReorderComponentsRequest;
export type ReorderPolicyPlanComponentsMutationError = ErrorType<PraetoidError>;

/**
 * @summary Reorder policy plan components
 */
export const useReorderPolicyPlanComponents = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof reorderPolicyPlanComponents>>,
			TError,
			{ id: string; data: ReorderComponentsRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof reorderPolicyPlanComponents>>,
	TError,
	{ id: string; data: ReorderComponentsRequest },
	TContext
> => {
	return useMutation(getReorderPolicyPlanComponentsMutationOptions(options), queryClient);
};
/**
 * Removes a component from a policy plan (triggers COW if needed)
 * @summary Delete a policy plan component
 */
export const deletePolicyPlanComponent = (id: string, componentId: string) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans/${id}/components/${componentId}`,
		method: 'DELETE'
	});
};

export const getDeletePolicyPlanComponentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deletePolicyPlanComponent>>,
		TError,
		{ id: string; componentId: string },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deletePolicyPlanComponent>>,
	TError,
	{ id: string; componentId: string },
	TContext
> => {
	const mutationKey = ['deletePolicyPlanComponent'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deletePolicyPlanComponent>>,
		{ id: string; componentId: string }
	> = (props) => {
		const { id, componentId } = props ?? {};

		return deletePolicyPlanComponent(id, componentId);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeletePolicyPlanComponentMutationResult = NonNullable<
	Awaited<ReturnType<typeof deletePolicyPlanComponent>>
>;

export type DeletePolicyPlanComponentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Delete a policy plan component
 */
export const useDeletePolicyPlanComponent = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deletePolicyPlanComponent>>,
			TError,
			{ id: string; componentId: string },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof deletePolicyPlanComponent>>,
	TError,
	{ id: string; componentId: string },
	TContext
> => {
	return useMutation(getDeletePolicyPlanComponentMutationOptions(options), queryClient);
};
/**
 * Updates a component on a policy plan (triggers COW if needed)
 * @summary Update a policy plan component
 */
export const updatePolicyPlanComponent = (
	id: string,
	componentId: string,
	updateComponentRequest: UpdateComponentRequest
) => {
	return customInstance<PolicyPlan>({
		url: `/policy-plans/${id}/components/${componentId}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: updateComponentRequest
	});
};

export const getUpdatePolicyPlanComponentMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePolicyPlanComponent>>,
		TError,
		{ id: string; componentId: string; data: UpdateComponentRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePolicyPlanComponent>>,
	TError,
	{ id: string; componentId: string; data: UpdateComponentRequest },
	TContext
> => {
	const mutationKey = ['updatePolicyPlanComponent'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePolicyPlanComponent>>,
		{ id: string; componentId: string; data: UpdateComponentRequest }
	> = (props) => {
		const { id, componentId, data } = props ?? {};

		return updatePolicyPlanComponent(id, componentId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePolicyPlanComponentMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePolicyPlanComponent>>
>;
export type UpdatePolicyPlanComponentMutationBody = UpdateComponentRequest;
export type UpdatePolicyPlanComponentMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update a policy plan component
 */
export const useUpdatePolicyPlanComponent = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePolicyPlanComponent>>,
			TError,
			{ id: string; componentId: string; data: UpdateComponentRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePolicyPlanComponent>>,
	TError,
	{ id: string; componentId: string; data: UpdateComponentRequest },
	TContext
> => {
	return useMutation(getUpdatePolicyPlanComponentMutationOptions(options), queryClient);
};
/**
 * Returns all versions for a policy plan
 * @summary List policy plan versions
 */
export const listPolicyPlanVersions = (id: string) => {
	return customInstance<PolicyPlanVersionListResponse>({
		url: `/policy-plans/${id}/versions`,
		method: 'GET'
	});
};

export const getListPolicyPlanVersionsQueryKey = (id: string) => {
	return ['policy-plans', id, 'versions'] as const;
};

export const getListPolicyPlanVersionsQueryOptions = <
	TData = Awaited<ReturnType<typeof listPolicyPlanVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanVersions>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPolicyPlanVersionsQueryKey(id);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyPlanVersions>>> = () =>
		listPolicyPlanVersions(id);

	return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPolicyPlanVersions>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPolicyPlanVersionsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPolicyPlanVersions>>
>;
export type ListPolicyPlanVersionsQueryError = ErrorType<PraetoidError>;

export function useListPolicyPlanVersions<
	TData = Awaited<ReturnType<typeof listPolicyPlanVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanVersions>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlanVersions>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlanVersions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlanVersions<
	TData = Awaited<ReturnType<typeof listPolicyPlanVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanVersions>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlanVersions>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlanVersions>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlanVersions<
	TData = Awaited<ReturnType<typeof listPolicyPlanVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanVersions>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List policy plan versions
 */

export function useListPolicyPlanVersions<
	TData = Awaited<ReturnType<typeof listPolicyPlanVersions>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlanVersions>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPolicyPlanVersionsQueryOptions(id, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a policy plan version by version ID.
 * @summary Get a policy plan version
 */
export const getPolicyPlanVersion = (id: string, version: string) => {
	return customInstance<PolicyPlanVersion>({
		url: `/policy-plans/${id}/versions/${version}`,
		method: 'GET'
	});
};

export const getGetPolicyPlanVersionQueryKey = (id: string, version: string) => {
	return ['policy-plans', id, 'versions', version] as const;
};

export const getGetPolicyPlanVersionQueryOptions = <
	TData = Awaited<ReturnType<typeof getPolicyPlanVersion>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	version: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPolicyPlanVersion>>, TError, TData>
		>;
	}
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetPolicyPlanVersionQueryKey(id, version);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getPolicyPlanVersion>>> = () =>
		getPolicyPlanVersion(id, version);

	return { queryKey, queryFn, enabled: !!(id && version), ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getPolicyPlanVersion>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPolicyPlanVersionQueryResult = NonNullable<
	Awaited<ReturnType<typeof getPolicyPlanVersion>>
>;
export type GetPolicyPlanVersionQueryError = ErrorType<PraetoidError>;

export function useGetPolicyPlanVersion<
	TData = Awaited<ReturnType<typeof getPolicyPlanVersion>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	version: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPolicyPlanVersion>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getPolicyPlanVersion>>,
					TError,
					Awaited<ReturnType<typeof getPolicyPlanVersion>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPolicyPlanVersion<
	TData = Awaited<ReturnType<typeof getPolicyPlanVersion>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	version: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPolicyPlanVersion>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getPolicyPlanVersion>>,
					TError,
					Awaited<ReturnType<typeof getPolicyPlanVersion>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPolicyPlanVersion<
	TData = Awaited<ReturnType<typeof getPolicyPlanVersion>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	version: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPolicyPlanVersion>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a policy plan version
 */

export function useGetPolicyPlanVersion<
	TData = Awaited<ReturnType<typeof getPolicyPlanVersion>>,
	TError = ErrorType<PraetoidError>
>(
	id: string,
	version: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getPolicyPlanVersion>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetPolicyPlanVersionQueryOptions(id, version, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all policy plans for the organization
 * @summary Get all policy plans
 */
export const listPolicyPlansSync = () => {
	return customInstance<PolicyPlanListResponse>({ url: `/sync/policy-plans`, method: 'GET' });
};

export const getListPolicyPlansSyncQueryKey = () => {
	return ['sync', 'policy-plans'] as const;
};

export const getListPolicyPlansSyncQueryOptions = <
	TData = Awaited<ReturnType<typeof listPolicyPlansSync>>,
	TError = ErrorType<PraetoidError>
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlansSync>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListPolicyPlansSyncQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listPolicyPlansSync>>> = () =>
		listPolicyPlansSync();

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listPolicyPlansSync>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPolicyPlansSyncQueryResult = NonNullable<
	Awaited<ReturnType<typeof listPolicyPlansSync>>
>;
export type ListPolicyPlansSyncQueryError = ErrorType<PraetoidError>;

export function useListPolicyPlansSync<
	TData = Awaited<ReturnType<typeof listPolicyPlansSync>>,
	TError = ErrorType<PraetoidError>
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlansSync>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlansSync>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlansSync>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlansSync<
	TData = Awaited<ReturnType<typeof listPolicyPlansSync>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlansSync>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listPolicyPlansSync>>,
					TError,
					Awaited<ReturnType<typeof listPolicyPlansSync>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListPolicyPlansSync<
	TData = Awaited<ReturnType<typeof listPolicyPlansSync>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlansSync>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get all policy plans
 */

export function useListPolicyPlansSync<
	TData = Awaited<ReturnType<typeof listPolicyPlansSync>>,
	TError = ErrorType<PraetoidError>
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listPolicyPlansSync>>, TError, TData>
		>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getListPolicyPlansSyncQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a policy plan's details. Only custom policy plans belonging to the organization can be updated.
 * @summary Update a policy plan
 */
export const updatePolicyPlanSync = (
	id: string,
	updatePolicyPlanRequest: UpdatePolicyPlanRequest
) => {
	return customInstance<PolicyPlan>({
		url: `/sync/policy-plans/${id}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: updatePolicyPlanRequest
	});
};

export const getUpdatePolicyPlanSyncMutationOptions = <
	TError = ErrorType<PraetoidError>,
	TContext = unknown
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updatePolicyPlanSync>>,
		TError,
		{ id: string; data: UpdatePolicyPlanRequest },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updatePolicyPlanSync>>,
	TError,
	{ id: string; data: UpdatePolicyPlanRequest },
	TContext
> => {
	const mutationKey = ['updatePolicyPlanSync'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updatePolicyPlanSync>>,
		{ id: string; data: UpdatePolicyPlanRequest }
	> = (props) => {
		const { id, data } = props ?? {};

		return updatePolicyPlanSync(id, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdatePolicyPlanSyncMutationResult = NonNullable<
	Awaited<ReturnType<typeof updatePolicyPlanSync>>
>;
export type UpdatePolicyPlanSyncMutationBody = UpdatePolicyPlanRequest;
export type UpdatePolicyPlanSyncMutationError = ErrorType<PraetoidError>;

/**
 * @summary Update a policy plan
 */
export const useUpdatePolicyPlanSync = <TError = ErrorType<PraetoidError>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updatePolicyPlanSync>>,
			TError,
			{ id: string; data: UpdatePolicyPlanRequest },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof updatePolicyPlanSync>>,
	TError,
	{ id: string; data: UpdatePolicyPlanRequest },
	TContext
> => {
	return useMutation(getUpdatePolicyPlanSyncMutationOptions(options), queryClient);
};
